import { toast } from 'react-toastify';
import { Uuid } from '@/api/types';
import { retrieveUnifiedError } from '@/api/utils';
import { useAssignUserToCaseGroup } from '@/queries/case';
import { CaseUserGroup } from '@/api/apis/case';

export const useDetachAssignedUser = ({ caseId }: { caseId: Uuid }) => {
  const { mutateAsync: mutateDetach, isPending: isPendingDetach } = useAssignUserToCaseGroup();

  const handleDetach = async ({
    customerId,
    employeeId,
    group,
  }: {
    customerId?: string;
    employeeId?: string;
    group: CaseUserGroup;
  }) => {
    try {
      await mutateDetach({ caseId, payload: [{ action: 'unassign', customerId, employeeId, group }] });
      toast.success('Resource has been successfully detached');
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return { handleDetach, isPendingDetach };
};
